import { createSlice } from "@reduxjs/toolkit";
import { BaseApiState } from "../../api/axiosConfig";
import { SendEmailFitersData } from "../../api/sendEmailApi";
import {
  fetchSendEmails,
  loadSendEmailFiltersData,
} from "../actions/sendEmailAction";

export interface SendEmailState extends BaseApiState {
  refreshNeeded: boolean;
  loadingSendEmail: boolean;
  succeededSendEmail: boolean;
  loadingSendEmailFilters: boolean;
  filters: SendEmailFitersData | null;
}

const sendEmailInitialState: SendEmailState = {
  succeededSendEmail: false,
  loadingSendEmail: false,
  loadingSendEmailFilters: false,
  refreshNeeded: false,
  loading: false,
  error: false,
  errorMessage: undefined,
  errorDetails: undefined,
  succeeded: false,
  filters: null,
};

const SendEmailSlice = createSlice({
  name: "sendEmail",
  initialState: sendEmailInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadSendEmailFiltersData.pending, (state) => {
        state.filters = null;
        state.loadingSendEmailFilters = true;
        state.loadingSendEmail = false;
        state.succeededSendEmail = false;
      })
      .addCase(loadSendEmailFiltersData.rejected, (state) => {
        state.succeededSendEmail = false;
        state.filters = null;
        state.loadingSendEmailFilters = false;
        state.loadingSendEmail = false;
        state.error = true;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
      })
      .addCase(loadSendEmailFiltersData.fulfilled, (state, action) => {
        state.succeededSendEmail = false;
        state.loadingSendEmail = false;
        state.filters = action.payload;
        state.loadingSendEmailFilters = false;
        state.succeeded = true;
        state.refreshNeeded = false;
      })
      .addCase(fetchSendEmails.pending, (state) => {
        state.loadingSendEmail = true;
        state.succeededSendEmail = false;
      })
      .addCase(fetchSendEmails.rejected, (state) => {
        state.loadingSendEmail = false;
        state.error = true;
        state.errorMessage = undefined;
        state.errorDetails = undefined;
        state.succeededSendEmail = false;
      })
      .addCase(fetchSendEmails.fulfilled, (state) => {
        state.loadingSendEmail = false;
        state.succeededSendEmail = true;
        state.refreshNeeded = false;
      });
  },
});

export const sendEmailReducer = SendEmailSlice.reducer;
